/**
 * Normalized single-letter display codes for worklist demographics (RIS + DICOM).
 */

export const WORKLIST_GENDER_DISPLAY = {
  MALE: 'M',
  FEMALE: 'F',
  OTHER: 'O',
  UNKNOWN: 'U',
};

/** Lowercase API / free-text tokens → display code */
export const WORKLIST_GENDER_FROM_API_TOKEN = Object.freeze({
  m: WORKLIST_GENDER_DISPLAY.MALE,
  male: WORKLIST_GENDER_DISPLAY.MALE,
  f: WORKLIST_GENDER_DISPLAY.FEMALE,
  female: WORKLIST_GENDER_DISPLAY.FEMALE,
  o: WORKLIST_GENDER_DISPLAY.OTHER,
  other: WORKLIST_GENDER_DISPLAY.OTHER,
  u: WORKLIST_GENDER_DISPLAY.UNKNOWN,
  unknown: WORKLIST_GENDER_DISPLAY.UNKNOWN,
});
